export default __webpack_public_path__ + "static/13-59e054ae94377a4b48fe1a5092de95b7.jpg";